// import {
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Paper
// } from '@mui/material';
// import noDataFound from '../../assets/images/no-data-found.svg'

// const AdvanceFilterTable = ({ tableData, loading, setLoading }) => {
//     // Dynamically get table headers from first object keys
//     const columns = tableData.length > 0 ? Object.keys(tableData[0]) : [];

//     return (
//         <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container'>
//             <Table>
//                 <TableHead>
//                     <TableRow>
//                         {columns.map((col) => (
//                             <TableCell key={col} className='table-header-div'>
//                                 {col}
//                             </TableCell>
//                         ))}
//                     </TableRow>
//                 </TableHead>
//                 <TableBody>
//                     {tableData.length > 0 ? (
//                         tableData.map((row, rowIndex) => (
//                             <TableRow key={rowIndex}>
//                                 {columns.map((col) => (
//                                     <TableCell key={col}>{row[col]}</TableCell>
//                                 ))}
//                             </TableRow>
//                         ))
//                     ) : (
//                         <TableRow>
//                             <TableCell colSpan={columns.length || 1} align="center">
//                                 <img
//                                     src={noDataFound}
//                                     alt="No Data Found"
//                                     style={{ height: "250px", width: "280px" }}
//                                 />
//                             </TableCell>
//                         </TableRow>
//                     )}
//                 </TableBody>
//             </Table>
//         </TableContainer>
//     );
// };

// export default AdvanceFilterTable;





import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Skeleton
} from '@mui/material';
import noDataFound from '../../assets/images/no-data-found.svg';
import PaginationComponent from '../PaginationComponent';

const AdvanceFilterTable = ({ tableData = [], loading, totalDataCount, setPage, setRowsPerPage, rowsPerPage }) => {
    const placeholderColumnCount = 5;
    const columns =
        tableData.length > 0
            ? Object.keys(tableData[0])
            : loading
                ? Array.from({ length: placeholderColumnCount }, (_, i) => `Column ${i + 1}`)
                : [];

    const handlePageChange = (newPage) => {
        setPage(newPage); // Handle 1-based to 0-based page index for slicing
    };
    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        setPage(0); // Reset to the first page when rows per page changes
    };

    return (
        <>
            <TableContainer component={Paper} sx={{ maxHeight: 440 }} className="table-container">
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            {columns.map((col, index) => (
                                <TableCell key={index} className="table-header-div">
                                    {loading ? <Skeleton variant="text" width={80} /> : col}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ? (
                            [...Array(5)].map((_, rowIndex) => (
                                <TableRow key={rowIndex}>
                                    {columns.map((_, colIndex) => (
                                        <TableCell key={colIndex}>
                                            <Skeleton variant="text" width="100%" />
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))
                        ) : tableData.length > 0 ? (
                            tableData.map((row, rowIndex) => (
                                <TableRow key={rowIndex}>
                                    {columns.map((col, colIndex) => (
                                        <TableCell key={colIndex}>{row[col]}</TableCell>
                                    ))}
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={columns.length || 1} align="center">
                                    <img
                                        src={noDataFound}
                                        alt="No Data Found"
                                        style={{ height: '250px', width: '280px' }}
                                    />
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <PaginationComponent
                totalItems={totalDataCount}
                itemsPerPage={rowsPerPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
            />
        </>
    );
};

export default AdvanceFilterTable;

